import { v2ConfigMapper } from './v2/v2ConfigMapper';

export default function mapConfigurationVersion(config) {
    if (config.version === '2.0.0') {
        return v2ConfigMapper(config);
    }

    return config;
}
